import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IdsMainButtonModule, IdsIconModule } from '@ids/angular';

import { SessionExpiredModalErrorComponent } from './components/session-expired-modal-error/session-expired-modal-error.component';

@NgModule({
  declarations: [SessionExpiredModalErrorComponent],
  imports: [CommonModule, IdsIconModule, IdsMainButtonModule],
  exports: [SessionExpiredModalErrorComponent]
})
export class ErrorTreatmentModule {}
